import { useContext } from "react";

import RenderStringHtml from "shared/components/atoms/RenderStringHtml";
import GlobalContext from "shared/providers/context/GlobalContext";

import { ContainerDescriptionBottom, SpanDescription } from "./styles";

const DescriptionBottom = () => {
  const { state } = useContext(GlobalContext);

  return (
    <ContainerDescriptionBottom>
      <SpanDescription>
        <RenderStringHtml
          value={state?.tenancy?.settings?.users?.userSignUpDescriptionBottom}
        />
      </SpanDescription>
    </ContainerDescriptionBottom>
  );
};

export default DescriptionBottom;
